import React from 'react';
import {
  CardHeader,
  CardContent,
  List,
} from '@fortress-technology-solutions/fortress-component-library/Atoms';

const HouseholdMemberCardContent = ({ avatar, title, subheader, children }) => {
  return (
    <>
      <CardHeader avatar={avatar} title={title} subheader={subheader} />

      <CardContent>
        <List>{children}</List>
      </CardContent>
    </>
  );
};

export default HouseholdMemberCardContent;
